import Icon from '../components/Icon';

export const svgContents = (
  <>
    <rect width="24" height="24" rx="2" fill="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.68 12.182c0-.568-.05-1.113-.145-1.637H12v3.095h4.305a3.68 3.68 0 0 1-1.596 2.415v2.007h2.585c1.513-1.393 2.386-3.444 2.386-5.88Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20c2.16 0 3.97-.716 5.294-1.938l-2.585-2.007c-.716.48-1.633.763-2.71.763-2.083 0-3.846-1.407-4.475-3.298H4.85v2.073A7.997 7.997 0 0 0 12 20Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.524 13.52A4.81 4.81 0 0 1 7.273 12c0-.527.09-1.04.25-1.52V8.407H4.852A7.997 7.997 0 0 0 4 12c0 1.29.31 2.513.85 3.593l2.674-2.073Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7.182c1.175 0 2.229.403 3.058 1.196l2.295-2.294C15.967 4.793 14.156 4 12 4a7.997 7.997 0 0 0-7.15 4.407l2.674 2.073C8.153 8.59 9.916 7.182 12 7.182Z"
      fill="#EA4335"
    />
  </>
);

const Google = Icon('google', svgContents);

export default Google;
